import { RoleType } from "@/enum/role.type";
import { ChallengeSettings } from "@/model/ChallengeSettings.model";
import { IFileModel } from "@/model/FileModel.model";
import { Game } from "@/model/Game.model";
import { User } from "@/model/User.model";

//declare state
export type State = {
  user: User;
  language: string;
  games: Game[];
  filterGame: string[];
  searchGame: string;
  gameSelected: Game;
  challengeSettings: ChallengeSettings[];
  challengeSettingSelected: ChallengeSettings;
  fileAwaitUpload: IFileModel[];
};

//set state
export const state: State = {
  language: "",
  user: {
    uid: "",
    email: "",
    displayName: "",
    phoneNumber: "",
    photoURL: "",
    roles: [RoleType.user]
  },
  games: [],
  filterGame: [],
  searchGame: "",
  gameSelected: {
    genre: "",
    id: 0,
    imageUrl: "",
    name: "",
    length: "",
    tag: "",
    description: ""
  },
  challengeSettings: [],
  challengeSettingSelected: {
    id: 0,
    name: "",
    description: "",
    settings: []
  },
  fileAwaitUpload: []
};
